'use strict';

angular.module('rmOrganisation')
    .controller('OrganisationOverviewCtrl', require('./organisation_overview_ctrl'));
